import React, {FC} from "react"
import {Body, H1, H4, Label} from "@irati/ui/src/Typography"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {Checkbox} from "@irati/ui/src/FormItem"
import Link from "@irati/ui/src/Link"
import {Card, Row} from "@irati/ui/src/Layout"
import Validation from "@irati/utils/validation"

interface Props extends InjectIntl {
  onChange: () => void
  termsAgreed: boolean
}

const TermsAndConditionsSection: FC<Props> = ({onChange, termsAgreed, formatMessage}) => (
  <Card>
    <H1 marginTop={2}>
      <FormattedMessage id="wellness.rentalMedia.redemption.payWithFlexiPoints" />
    </H1>
    <H4 margin={[2, 0]}>
      <FormattedMessage
        id="wellness.rentalMedia.redemption.nonRefundablePayment.header"
        values={{
          boldText: <FormattedMessage id="wellness.rentalMedia.redemption.nonRefundablePayment.boldText" />
        }}
      />
    </H4>
    <Body marginBottom={4}>
      <FormattedMessage id="wellness.rentalMedia.redemption.termsAndConditions.header" />
    </Body>
    <Row>
      <Flex marginBottom={4}>
        <Checkbox
          name="checkWellnesTandC"
          onChange={onChange}
          checked={termsAgreed}
          validation={Validation.bool().oneOf([true], formatMessage({id: "platform.defaultValidation.required"}))}>
          <Label large htmlFor="checkWellnesTandC" id="checkWellnesTandC">
            <FormattedMessage
              id="wellness.rentalMedia.redemption.termsAndConditions.body"
              values={{
                link: (
                  <Link cta href={formatMessage({id: "wellness.rentalMedia.redemption.termsAndConditions.link.href"})} target="_blank">
                    <FormattedMessage id="wellness.rentalMedia.redemption.termsAndConditions.link.text" />
                  </Link>
                )
              }}
            />
          </Label>
        </Checkbox>
      </Flex>
    </Row>
  </Card>
)

export default injectIntl(TermsAndConditionsSection)
